export default __webpack_public_path__ + "static/media/Trezor.04ef0d27.svg";